/* Purry Home — mobile announcement bar: one message at a time, rotating every 4 s
   (design-system/shopify.md §6). Desktop keeps the full " · "-joined line. */
(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const el = document.querySelector('.announcement-bar__message');
  if (!el) return;
  let timer = null, i = 0;
  const full = () => (el.dataset.phFull || el.textContent).trim();
  const parts = () => full().split(' · ').map((s) => s.trim()).filter(Boolean);
  function stop() { if (timer) clearInterval(timer); timer = null; if (el.dataset.phFull) el.textContent = el.dataset.phFull; el.classList.remove('ph-ann-rotating', 'is-out'); }
  function start() {
    stop();
    const ps = parts();
    if (ps.length < 2) return;
    if (!el.dataset.phFull) el.dataset.phFull = full();
    el.classList.add('ph-ann-rotating');
    i = 0; el.textContent = ps[0];
    timer = setInterval(() => {
      el.classList.add('is-out');
      setTimeout(() => { i = (i + 1) % ps.length; el.textContent = ps[i]; el.classList.remove('is-out'); }, 250);
    }, 4000);
  }
  const apply = () => (mq.matches ? start() : stop());
  apply();
  mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply);
  document.addEventListener('ph:region', (e) => {
    if (e.detail === 'US' && el.dataset.phFull) el.dataset.phFull = el.dataset.phFull.replace(/\bUK\b/g, 'US');
    apply();
  });
})();
